function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M480-240q-38 0-73.5-10.5T341-281q-44-3-90-19t-84-53q-38-37-62.5-97T80-600v-20q0-42 29-71t71-29q39 0 67.5 27t31.5 65q28-8 50-20t45-23q23-12 48-20.5t58-8.5q34 0 58.5 8.5T586-671q22 11 44.5 23t50.5 20q3-39 31.5-65.5T780-720q42 0 71 29t29 71v20q0 90-24.5 150T793-353q-38 37-84 53t-90 19q-30 20-65.5 30.5T480-240zM260-361q-19-30-29.5-65.5T220-500v-120q0-17-11.5-28.5T180-660q-17 0-28.5 11.5T140-620v20q0 110 37 164t83 75zm220 61q83 0 141.5-58.5T680-500v-66q-34-8-59.5-19T574-609q-28-17-49.5-24t-44.5-7q-23 0-44.5 7T386-609q-21 12-46.5 24T280-566v66q0 83 58.5 141.5T480-300zm0-260q15 0 26.5 5.5T532-541q8 5 15.5 9t16.5 9q8 4 16 .5t12-11.5q4-8 0-15t-12-11q-8-4-14.5-7.5T552-575q-16-10-32.5-17.5T480-600q-23 0-39.5 7.5T407-575q-7 4-13.5 7.5T379-560q-8 4-11.5 11t.5 15q4 8 12 11t16-1q9-5 16.5-9t15.5-8q14-8 25.5-13.5T480-560zm220 199q46-21 83-75t37-164v-20q0-17-11.5-28.5T780-660q-17 0-28.5 11.5T740-620v120q0 38-10 73.5T700-361zM480-470z"
  }));
};
const SvgMask = styled(BaseComponent).withConfig({
  displayName: "Mask__SvgMask",
  componentId: "sc-161zq4i-0"
})(["outline:none;"]);
SvgMask.isIcon = true;
export default SvgMask;